export const loadUsageCount = () => {
  const usageData = JSON.parse(localStorage.getItem("usageCount")) || {};
  const today = new Date().toISOString().split("T")[0];
  return usageData.date === today ? usageData.count : 0;
};

export const incrementUsageCount = (currentCount) => {
  const today = new Date().toISOString().split("T")[0];
  const newCount = currentCount + 1;
  localStorage.setItem("usageCount", JSON.stringify({ date: today, count: newCount }));
  return newCount;
};
